export function useComponentLabels() {
  const allData = {
    allTaxonomyTermComponentLabels: {
      edges: [
        {
          node: {
            drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
            name: 'Video Player',
            langcode: 'en',
            weight: 37,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'bb8d18a8-84cd-46b4-84a2-9c6bc56e5c26',
                  name: 'Now Playing:',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>titlePlaying</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '451375e7-8d76-4317-a82f-864b0202b351',
                  name: 'Close video',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>labelButtonClose</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
            name: 'Fascinator',
            langcode: 'en',
            weight: 38,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                  name: 'Exterior',
                  langcode: 'en',
                  weight: 0,
                  description: null,
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                      },
                    ],
                    taxonomy_term__component_labels: [
                      {
                        drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
                        name: 'Color / Wheels',
                        langcode: 'en',
                        weight: 0,
                        description: {
                          processed: '<p>paint</p>\n',
                        },
                      },
                      {
                        drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
                        name: 'Background',
                        langcode: 'en',
                        weight: 1,
                        description: {
                          processed: '<p>environment</p>\n',
                        },
                      },
                    ],
                  },
                },
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                  name: 'Interior',
                  langcode: 'en',
                  weight: 1,
                  description: null,
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                      },
                    ],
                    taxonomy_term__component_labels: [
                      {
                        drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
                        name: 'Interior',
                        langcode: 'en',
                        weight: 0,
                        description: {
                          processed: '<p>theme</p>\n',
                        },
                      },
                      {
                        drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
                        name: 'Background',
                        langcode: 'en',
                        weight: 1,
                        description: {
                          processed: '<p>environment</p>\n',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
            name: 'Electrify America Map',
            langcode: 'en',
            weight: 39,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '3e9ce828-42f0-45d8-9d59-0859f907ec92',
                  name: 'Search City, Country',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>placeholder</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'fe8a4823-48ad-4c61-8246-f41d01314495',
                  name: 'Filters',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>filters</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '5b5054b0-2efa-4db4-a643-9aa5d004e556',
                  name: 'Hide Filter',
                  langcode: 'en',
                  weight: 2,
                  description: {
                    processed: '<p>hide-filter</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'a187ca01-36a9-47b5-af88-c0709f7c48a6',
                  name: 'Location',
                  langcode: 'en',
                  weight: 3,
                  description: {
                    processed: '<p>location</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'e29ff987-e68a-4152-8b27-dccba423ca46',
                  name: 'Locations',
                  langcode: 'en',
                  weight: 4,
                  description: {
                    processed: '<p>locations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '117c168b-0efe-4be7-a18f-04ab920761fb',
                  name: 'No results',
                  langcode: 'en',
                  weight: 5,
                  description: {
                    processed: '<p>no-results</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'd2d9f25d-4a25-4918-ba76-276792111331',
                  name: 'Back',
                  langcode: 'en',
                  weight: 6,
                  description: {
                    processed: '<p>back</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'ca5e6ebc-7cd0-4828-8e73-d9ee248a7641',
                  name: 'Driving Directions',
                  langcode: 'en',
                  weight: 7,
                  description: {
                    processed: '<p>driving-directions</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '26530d8e-bbb7-4f66-9e19-0ff9fac5af21',
                  name: 'Studio',
                  langcode: 'en',
                  weight: 8,
                  description: {
                    processed: '<p>studio</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '19b9ba81-727a-45a8-ba07-a6976af8a3c6',
                  name: 'Service center',
                  langcode: 'en',
                  weight: 9,
                  description: {
                    processed: '<p>service-center</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '58f797a1-c9aa-4969-874a-971e353e8f38',
                  name: 'Charger',
                  langcode: 'en',
                  weight: 10,
                  description: {
                    processed: '<p>charging-station</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '19314a79-2d4e-43f7-bc71-d4a5b64d694b',
                  name: 'Coming soon',
                  langcode: 'en',
                  weight: 11,
                  description: {
                    processed: '<p>coming-soon</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '98828aee-50d3-41c7-be6c-d7e117f93d30',
                  name: 'Show filter',
                  langcode: 'en',
                  weight: 12,
                  description: {
                    processed: '<p>show-filters</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '6af274ce-950e-48ad-8a88-bd7735e437bf',
                  name: 'Map View',
                  langcode: 'en',
                  weight: 13,
                  description: {
                    processed: '<p>map-view</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '933e0a60-4992-404e-94cb-cfb6954cabb4',
                  name: 'List View',
                  langcode: 'en',
                  weight: 14,
                  description: {
                    processed: '<p>list-view</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '9e888882-d71e-4170-bf68-ad39026bb135',
                  name: 'Clear',
                  langcode: 'en',
                  weight: 15,
                  description: {
                    processed: '<p>clear</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '0b703fdd-5d9a-410e-aecf-6b9e09aba1f2',
                  name: 'Apply',
                  langcode: 'en',
                  weight: 16,
                  description: {
                    processed: '<p>apply</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '897d8c45-df2f-4a08-a618-0d1f6e3847a2',
                  name: 'Search',
                  langcode: 'en',
                  weight: 17,
                  description: {
                    processed: '<p>searchSubmit</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '96e370e6-e891-4e1b-85b4-885c94c495c8',
                  name: 'Clear input',
                  langcode: 'en',
                  weight: 18,
                  description: {
                    processed: '<p>clearInput</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'f8660042-4544-4f26-824b-5c77097d8793',
                  name: 'Use geolocation',
                  langcode: 'en',
                  weight: 19,
                  description: {
                    processed: '<p>geoLocation</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
            name: 'Image/Video Loop',
            langcode: 'en',
            weight: 40,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '513de3d9-a963-4788-befa-83d4fb359993',
                  name: 'Play video',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>playVideoButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
            name: 'Header',
            langcode: 'en',
            weight: 41,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '144d7db4-24b0-4b40-b3ba-006a6e88ba5a',
                  name: 'Lucid home',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>logo</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'dd427311-f0f3-4283-9cf9-3f6630dce7f3',
                  name: 'Menu',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>hamburger</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '96d6dc56-e599-4ee5-85ed-92704f5a46ee',
                  name: 'Skip to main content',
                  langcode: 'en',
                  weight: 2,
                  description: {
                    processed: '<p>skip-to-main-content</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '588bf7f0-219a-4129-9d80-2b1de2b09901',
                  name: 'Play animations',
                  langcode: 'en',
                  weight: 3,
                  description: {
                    processed: '<p>enable-animations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'ce498339-3b3e-4724-a196-7d9a8b8e00b5',
                  name: 'Pause animations',
                  langcode: 'en',
                  weight: 4,
                  description: {
                    processed: '<p>disable-animations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '435c4f40-eeeb-42dd-b2fc-d64d9e46b869',
                  name: 'Close Menu',
                  langcode: 'en',
                  weight: 5,
                  description: {
                    processed: '<p>close-side-menu</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
            name: 'Image Carousel',
            langcode: 'en',
            weight: 42,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'e4598129-1948-4231-813e-f879b5650e82',
                  name: 'Show next slide',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '243cc9e8-028b-4f0b-9b51-2ffe23585efe',
                  name: 'Show previous slide',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
            name: 'Trims',
            langcode: 'en',
            weight: 43,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '2182f223-4401-4d41-bdc4-b58f6227ae85',
                  name: 'Previous trim',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'a021dace-35a5-49f7-aae7-2d9c85c4e674',
                  name: 'Next trim',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
            name: 'Stories',
            langcode: 'en',
            weight: 44,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'c197b04a-bd7a-4f18-bb85-b6c2c8aac067',
                  name: 'Previous story',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'c5e01efb-131d-4c63-b7b2-39139703b71f',
                  name: 'Next story',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
            name: 'Disclaimers',
            langcode: 'en',
            weight: 45,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '58e55203-b82e-4f19-9401-1912f1fb76af',
                  name: 'Disclaimers',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>section-disclaimer-title</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
            name: 'Legal',
            langcode: 'en',
            weight: 50,
            description: {
              processed: '<p>legal</p>\n',
            },
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '161e7986-4e03-43c4-8f38-83fbcb0d3f80',
                  name: 'Open',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>reveal</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'cbc21ceb-a7b4-4604-9280-828d95ddf837',
                  name: 'Close',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>hide</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '7613a453-1466-4543-86b6-07e1c4bc1be2',
                  name: 'Download',
                  langcode: 'en',
                  weight: 2,
                  description: {
                    processed: '<p>download</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
            name: 'Video Player',
            langcode: 'ar',
            weight: 37,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'bb8d18a8-84cd-46b4-84a2-9c6bc56e5c26',
                  name: 'يعرض الآن:',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>titlePlaying</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '451375e7-8d76-4317-a82f-864b0202b351',
                  name: 'أغلق الفيديو',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>labelButtonClose</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
            name: 'Fascinator',
            langcode: 'ar',
            weight: 38,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                  name: 'Exterior',
                  langcode: 'ar',
                  weight: 0,
                  description: null,
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                      },
                    ],
                    taxonomy_term__component_labels: [
                      {
                        drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
                        name: 'الألوان / العجلات',
                        langcode: 'ar',
                        weight: 0,
                        description: {
                          processed: '<p>paint</p>\n',
                        },
                      },
                      {
                        drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
                        name: 'الخلفية',
                        langcode: 'ar',
                        weight: 1,
                        description: {
                          processed: '<p>environment</p>\n',
                        },
                      },
                    ],
                  },
                },
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                  name: 'Interior',
                  langcode: 'ar',
                  weight: 1,
                  description: null,
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                      },
                    ],
                    taxonomy_term__component_labels: [
                      {
                        drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
                        name: 'في الداخل',
                        langcode: 'ar',
                        weight: 0,
                        description: {
                          processed: '<p>theme</p>\n',
                        },
                      },
                      {
                        drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
                        name: 'الخلفية',
                        langcode: 'ar',
                        weight: 1,
                        description: {
                          processed: '<p>environment</p>\n',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
            name: 'Electrify America Map',
            langcode: 'ar',
            weight: 39,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '3e9ce828-42f0-45d8-9d59-0859f907ec92',
                  name: 'البحث عن مدينة، بلد',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>placeholder</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'fe8a4823-48ad-4c61-8246-f41d01314495',
                  name: 'فلاتر',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>filters</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '5b5054b0-2efa-4db4-a643-9aa5d004e556',
                  name: 'اخفي الفلتر',
                  langcode: 'ar',
                  weight: 2,
                  description: {
                    processed: '<p>hide-filter</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'a187ca01-36a9-47b5-af88-c0709f7c48a6',
                  name: 'موقع',
                  langcode: 'ar',
                  weight: 3,
                  description: {
                    processed: '<p>location</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'e29ff987-e68a-4152-8b27-dccba423ca46',
                  name: 'مواقع',
                  langcode: 'ar',
                  weight: 4,
                  description: {
                    processed: '<p>locations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '117c168b-0efe-4be7-a18f-04ab920761fb',
                  name: 'لا توجد نتائج',
                  langcode: 'ar',
                  weight: 5,
                  description: {
                    processed: '<p>no-results</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'd2d9f25d-4a25-4918-ba76-276792111331',
                  name: 'عودة',
                  langcode: 'ar',
                  weight: 6,
                  description: {
                    processed: '<p>back</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'ca5e6ebc-7cd0-4828-8e73-d9ee248a7641',
                  name: 'اتجاهات القيادة',
                  langcode: 'ar',
                  weight: 7,
                  description: {
                    processed: '<p>driving-directions</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '26530d8e-bbb7-4f66-9e19-0ff9fac5af21',
                  name: 'استوديو',
                  langcode: 'ar',
                  weight: 8,
                  description: {
                    processed: '<p>studio</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '19b9ba81-727a-45a8-ba07-a6976af8a3c6',
                  name: 'مركز خدمة',
                  langcode: 'ar',
                  weight: 9,
                  description: {
                    processed: '<p>service-center</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '58f797a1-c9aa-4969-874a-971e353e8f38',
                  name: 'شاحن',
                  langcode: 'ar',
                  weight: 10,
                  description: {
                    processed: '<p>charging-station</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '19314a79-2d4e-43f7-bc71-d4a5b64d694b',
                  name: 'قريباً',
                  langcode: 'ar',
                  weight: 11,
                  description: {
                    processed: '<p>coming-soon</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '98828aee-50d3-41c7-be6c-d7e117f93d30',
                  name: 'اعرض الفلتر',
                  langcode: 'ar',
                  weight: 12,
                  description: {
                    processed: '<p>show-filters</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '6af274ce-950e-48ad-8a88-bd7735e437bf',
                  name: 'عرض الخريطة',
                  langcode: 'ar',
                  weight: 13,
                  description: {
                    processed: '<p>map-view</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '933e0a60-4992-404e-94cb-cfb6954cabb4',
                  name: 'عرض القائمة',
                  langcode: 'ar',
                  weight: 14,
                  description: {
                    processed: '<p>list-view</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '9e888882-d71e-4170-bf68-ad39026bb135',
                  name: 'مسح',
                  langcode: 'ar',
                  weight: 15,
                  description: {
                    processed: '<p>clear</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '0b703fdd-5d9a-410e-aecf-6b9e09aba1f2',
                  name: 'تطبيق',
                  langcode: 'ar',
                  weight: 16,
                  description: {
                    processed: '<p>apply</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '897d8c45-df2f-4a08-a618-0d1f6e3847a2',
                  name: 'بحث',
                  langcode: 'ar',
                  weight: 17,
                  description: {
                    processed: '<p>searchSubmit</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '96e370e6-e891-4e1b-85b4-885c94c495c8',
                  name: 'مسح المدخلات',
                  langcode: 'ar',
                  weight: 18,
                  description: {
                    processed: '<p>clearInput</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'f8660042-4544-4f26-824b-5c77097d8793',
                  name: 'استخدام الموقع الجغرافي',
                  langcode: 'ar',
                  weight: 19,
                  description: {
                    processed: '<p>geoLocation</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
            name: 'Image/Video Loop',
            langcode: 'ar',
            weight: 40,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '513de3d9-a963-4788-befa-83d4fb359993',
                  name: 'شغل الفيديو',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>playVideoButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
            name: 'Header',
            langcode: 'ar',
            weight: 41,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '144d7db4-24b0-4b40-b3ba-006a6e88ba5a',
                  name: 'لوسِد الصفحة الرئيسية',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>logo</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'dd427311-f0f3-4283-9cf9-3f6630dce7f3',
                  name: 'قائمة',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>hamburger</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '96d6dc56-e599-4ee5-85ed-92704f5a46ee',
                  name: 'Skip to main content',
                  langcode: 'ar',
                  weight: 2,
                  description: {
                    processed: '<p>skip-to-main-content</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '588bf7f0-219a-4129-9d80-2b1de2b09901',
                  name: 'تشغيل الرسوم المتحركة',
                  langcode: 'ar',
                  weight: 3,
                  description: {
                    processed: '<p>enable-animations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'ce498339-3b3e-4724-a196-7d9a8b8e00b5',
                  name: 'إيقاف الرسوم المتحركة مؤقتًا',
                  langcode: 'ar',
                  weight: 4,
                  description: {
                    processed: '<p>disable-animations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '435c4f40-eeeb-42dd-b2fc-d64d9e46b869',
                  name: 'Close Menu',
                  langcode: 'ar',
                  weight: 5,
                  description: {
                    processed: '<p>close-side-menu</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
            name: 'Image Carousel',
            langcode: 'ar',
            weight: 42,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'e4598129-1948-4231-813e-f879b5650e82',
                  name: 'اعرض الشريحة التالية',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '243cc9e8-028b-4f0b-9b51-2ffe23585efe',
                  name: 'اعرض الشريحة السابقة',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
            name: 'Trims',
            langcode: 'ar',
            weight: 43,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '2182f223-4401-4d41-bdc4-b58f6227ae85',
                  name: 'الزخارف السابقة',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'a021dace-35a5-49f7-aae7-2d9c85c4e674',
                  name: 'الزخارف التالية',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
            name: 'Stories',
            langcode: 'ar',
            weight: 44,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'c197b04a-bd7a-4f18-bb85-b6c2c8aac067',
                  name: 'القصة السابقة',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'c5e01efb-131d-4c63-b7b2-39139703b71f',
                  name: 'القصة التالية',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
            name: 'Disclaimers',
            langcode: 'ar',
            weight: 45,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '58e55203-b82e-4f19-9401-1912f1fb76af',
                  name: 'Disclaimers',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>section-disclaimer-title</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
            name: 'Legal',
            langcode: 'ar',
            weight: 50,
            description: {
              processed: '<p>legal</p>\n',
            },
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '161e7986-4e03-43c4-8f38-83fbcb0d3f80',
                  name: 'افتح',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>reveal</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'cbc21ceb-a7b4-4604-9280-828d95ddf837',
                  name: 'قريب',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>hide</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '7613a453-1466-4543-86b6-07e1c4bc1be2',
                  name: 'تحميل',
                  langcode: 'ar',
                  weight: 2,
                  description: {
                    processed: '<p>download</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
            name: 'Video Player',
            langcode: 'en-ca',
            weight: 37,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'bb8d18a8-84cd-46b4-84a2-9c6bc56e5c26',
                  name: 'Now Playing:',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>titlePlaying</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '451375e7-8d76-4317-a82f-864b0202b351',
                  name: 'Close video',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>labelButtonClose</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
            name: 'Fascinator',
            langcode: 'en-ca',
            weight: 38,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                  name: 'Exterior',
                  langcode: 'en-ca',
                  weight: 0,
                  description: null,
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                      },
                    ],
                    taxonomy_term__component_labels: [
                      {
                        drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
                        name: 'Colour / Wheels',
                        langcode: 'en-ca',
                        weight: 0,
                        description: {
                          processed: '<p>paint</p>\n',
                        },
                      },
                      {
                        drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
                        name: 'Background',
                        langcode: 'en-ca',
                        weight: 1,
                        description: {
                          processed: '<p>environment</p>\n',
                        },
                      },
                    ],
                  },
                },
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                  name: 'Interior',
                  langcode: 'en-ca',
                  weight: 1,
                  description: null,
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                      },
                    ],
                    taxonomy_term__component_labels: [
                      {
                        drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
                        name: 'Interior',
                        langcode: 'en-ca',
                        weight: 0,
                        description: {
                          processed: '<p>theme</p>\n',
                        },
                      },
                      {
                        drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
                        name: 'Background',
                        langcode: 'en-ca',
                        weight: 1,
                        description: {
                          processed: '<p>environment</p>\n',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
            name: 'Electrify America Map',
            langcode: 'en-ca',
            weight: 39,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '3e9ce828-42f0-45d8-9d59-0859f907ec92',
                  name: 'Search City, Country',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>placeholder</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'fe8a4823-48ad-4c61-8246-f41d01314495',
                  name: 'Filters',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>filters</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '5b5054b0-2efa-4db4-a643-9aa5d004e556',
                  name: 'Hide Filter',
                  langcode: 'en-ca',
                  weight: 2,
                  description: {
                    processed: '<p>hide-filter</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'a187ca01-36a9-47b5-af88-c0709f7c48a6',
                  name: 'Location',
                  langcode: 'en-ca',
                  weight: 3,
                  description: {
                    processed: '<p>location</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'e29ff987-e68a-4152-8b27-dccba423ca46',
                  name: 'Locations',
                  langcode: 'en-ca',
                  weight: 4,
                  description: {
                    processed: '<p>locations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '117c168b-0efe-4be7-a18f-04ab920761fb',
                  name: 'No results',
                  langcode: 'en-ca',
                  weight: 5,
                  description: {
                    processed: '<p>no-results</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'd2d9f25d-4a25-4918-ba76-276792111331',
                  name: 'Back',
                  langcode: 'en-ca',
                  weight: 6,
                  description: {
                    processed: '<p>back</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'ca5e6ebc-7cd0-4828-8e73-d9ee248a7641',
                  name: 'Driving Directions',
                  langcode: 'en-ca',
                  weight: 7,
                  description: {
                    processed: '<p>driving-directions</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '26530d8e-bbb7-4f66-9e19-0ff9fac5af21',
                  name: 'Studio',
                  langcode: 'en-ca',
                  weight: 8,
                  description: {
                    processed: '<p>studio</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '19b9ba81-727a-45a8-ba07-a6976af8a3c6',
                  name: 'Service center',
                  langcode: 'en-ca',
                  weight: 9,
                  description: {
                    processed: '<p>service-center</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '58f797a1-c9aa-4969-874a-971e353e8f38',
                  name: 'Charger',
                  langcode: 'en-ca',
                  weight: 10,
                  description: {
                    processed: '<p>charging-station</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '19314a79-2d4e-43f7-bc71-d4a5b64d694b',
                  name: 'Coming soon',
                  langcode: 'en-ca',
                  weight: 11,
                  description: {
                    processed: '<p>coming-soon</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '98828aee-50d3-41c7-be6c-d7e117f93d30',
                  name: 'Show filter',
                  langcode: 'en-ca',
                  weight: 12,
                  description: {
                    processed: '<p>show-filters</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '6af274ce-950e-48ad-8a88-bd7735e437bf',
                  name: 'Map View',
                  langcode: 'en-ca',
                  weight: 13,
                  description: {
                    processed: '<p>map-view</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '933e0a60-4992-404e-94cb-cfb6954cabb4',
                  name: 'List View',
                  langcode: 'en-ca',
                  weight: 14,
                  description: {
                    processed: '<p>list-view</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '9e888882-d71e-4170-bf68-ad39026bb135',
                  name: 'Clear',
                  langcode: 'en-ca',
                  weight: 15,
                  description: {
                    processed: '<p>clear</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '0b703fdd-5d9a-410e-aecf-6b9e09aba1f2',
                  name: 'Apply',
                  langcode: 'en-ca',
                  weight: 16,
                  description: {
                    processed: '<p>apply</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '897d8c45-df2f-4a08-a618-0d1f6e3847a2',
                  name: 'Search',
                  langcode: 'en-ca',
                  weight: 17,
                  description: {
                    processed: '<p>searchSubmit</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '96e370e6-e891-4e1b-85b4-885c94c495c8',
                  name: 'Clear input',
                  langcode: 'en-ca',
                  weight: 18,
                  description: {
                    processed: '<p>clearInput</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'f8660042-4544-4f26-824b-5c77097d8793',
                  name: 'Use geolocation',
                  langcode: 'en-ca',
                  weight: 19,
                  description: {
                    processed: '<p>geoLocation</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
            name: 'Image/Video Loop',
            langcode: 'en-ca',
            weight: 40,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '513de3d9-a963-4788-befa-83d4fb359993',
                  name: 'Play video',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>playVideoButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
            name: 'Header',
            langcode: 'en-ca',
            weight: 41,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '144d7db4-24b0-4b40-b3ba-006a6e88ba5a',
                  name: 'Lucid home',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>logo</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'dd427311-f0f3-4283-9cf9-3f6630dce7f3',
                  name: 'Menu',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>hamburger</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '96d6dc56-e599-4ee5-85ed-92704f5a46ee',
                  name: 'Skip to main content',
                  langcode: 'en-ca',
                  weight: 2,
                  description: {
                    processed: '<p>skip-to-main-content</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '588bf7f0-219a-4129-9d80-2b1de2b09901',
                  name: 'Play animations',
                  langcode: 'en-ca',
                  weight: 3,
                  description: {
                    processed: '<p>enable-animations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'ce498339-3b3e-4724-a196-7d9a8b8e00b5',
                  name: 'Pause animations',
                  langcode: 'en-ca',
                  weight: 4,
                  description: {
                    processed: '<p>disable-animations</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '435c4f40-eeeb-42dd-b2fc-d64d9e46b869',
                  name: 'Close Menu',
                  langcode: 'en-ca',
                  weight: 5,
                  description: {
                    processed: '<p>close-side-menu</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
            name: 'Image Carousel',
            langcode: 'en-ca',
            weight: 42,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'e4598129-1948-4231-813e-f879b5650e82',
                  name: 'Show next slide',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '243cc9e8-028b-4f0b-9b51-2ffe23585efe',
                  name: 'Show previous slide',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
            name: 'Trims',
            langcode: 'en-ca',
            weight: 43,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '2182f223-4401-4d41-bdc4-b58f6227ae85',
                  name: 'Previous trim',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'a021dace-35a5-49f7-aae7-2d9c85c4e674',
                  name: 'Next trim',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
            name: 'Stories',
            langcode: 'en-ca',
            weight: 44,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'c197b04a-bd7a-4f18-bb85-b6c2c8aac067',
                  name: 'Previous story',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>arrowLeftButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'c5e01efb-131d-4c63-b7b2-39139703b71f',
                  name: 'Next story',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>arrowRightButton</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
            name: 'Disclaimers',
            langcode: 'en-ca',
            weight: 45,
            description: null,
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '58e55203-b82e-4f19-9401-1912f1fb76af',
                  name: 'Disclaimers',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>section-disclaimer-title</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
            name: 'Legal',
            langcode: 'en-ca',
            weight: 50,
            description: {
              processed: '<p>legal</p>\n',
            },
            relationships: {
              parent: [],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '161e7986-4e03-43c4-8f38-83fbcb0d3f80',
                  name: 'Open',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>reveal</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: 'cbc21ceb-a7b4-4604-9280-828d95ddf837',
                  name: 'Close',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>hide</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '7613a453-1466-4543-86b6-07e1c4bc1be2',
                  name: 'Download',
                  langcode: 'en-ca',
                  weight: 2,
                  description: {
                    processed: '<p>download</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'c197b04a-bd7a-4f18-bb85-b6c2c8aac067',
            name: 'Previous story',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'c5e01efb-131d-4c63-b7b2-39139703b71f',
            name: 'Next story',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
            name: 'Exterior',
            langcode: 'en',
            weight: 0,
            description: null,
            relationships: {
              parent: [
                {
                  drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                },
              ],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
                  name: 'Color / Wheels',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>paint</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
                  name: 'Background',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>environment</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
            name: 'Interior',
            langcode: 'en',
            weight: 1,
            description: null,
            relationships: {
              parent: [
                {
                  drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                },
              ],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
                  name: 'Interior',
                  langcode: 'en',
                  weight: 0,
                  description: {
                    processed: '<p>theme</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
                  name: 'Background',
                  langcode: 'en',
                  weight: 1,
                  description: {
                    processed: '<p>environment</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '58e55203-b82e-4f19-9401-1912f1fb76af',
            name: 'Disclaimers',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>section-disclaimer-title</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '58e55203-b82e-4f19-9401-1912f1fb76af',
            name: 'Disclaimers',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>section-disclaimer-title</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '3e9ce828-42f0-45d8-9d59-0859f907ec92',
            name: 'Search City, Country',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>placeholder</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'fe8a4823-48ad-4c61-8246-f41d01314495',
            name: 'Filters',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>filters</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '5b5054b0-2efa-4db4-a643-9aa5d004e556',
            name: 'Hide Filter',
            langcode: 'en-ca',
            weight: 2,
            description: {
              processed: '<p>hide-filter</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'a187ca01-36a9-47b5-af88-c0709f7c48a6',
            name: 'Location',
            langcode: 'en-ca',
            weight: 3,
            description: {
              processed: '<p>location</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'e29ff987-e68a-4152-8b27-dccba423ca46',
            name: 'Locations',
            langcode: 'en-ca',
            weight: 4,
            description: {
              processed: '<p>locations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '117c168b-0efe-4be7-a18f-04ab920761fb',
            name: 'No results',
            langcode: 'en-ca',
            weight: 5,
            description: {
              processed: '<p>no-results</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'd2d9f25d-4a25-4918-ba76-276792111331',
            name: 'Back',
            langcode: 'en-ca',
            weight: 6,
            description: {
              processed: '<p>back</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'ca5e6ebc-7cd0-4828-8e73-d9ee248a7641',
            name: 'Driving Directions',
            langcode: 'en-ca',
            weight: 7,
            description: {
              processed: '<p>driving-directions</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '26530d8e-bbb7-4f66-9e19-0ff9fac5af21',
            name: 'Studio',
            langcode: 'en-ca',
            weight: 8,
            description: {
              processed: '<p>studio</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '19b9ba81-727a-45a8-ba07-a6976af8a3c6',
            name: 'Service center',
            langcode: 'en-ca',
            weight: 9,
            description: {
              processed: '<p>service-center</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '58f797a1-c9aa-4969-874a-971e353e8f38',
            name: 'Charger',
            langcode: 'en-ca',
            weight: 10,
            description: {
              processed: '<p>charging-station</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '19314a79-2d4e-43f7-bc71-d4a5b64d694b',
            name: 'Coming soon',
            langcode: 'en-ca',
            weight: 11,
            description: {
              processed: '<p>coming-soon</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '98828aee-50d3-41c7-be6c-d7e117f93d30',
            name: 'Show filter',
            langcode: 'en-ca',
            weight: 12,
            description: {
              processed: '<p>show-filters</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '6af274ce-950e-48ad-8a88-bd7735e437bf',
            name: 'Map View',
            langcode: 'en-ca',
            weight: 13,
            description: {
              processed: '<p>map-view</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '933e0a60-4992-404e-94cb-cfb6954cabb4',
            name: 'List View',
            langcode: 'en-ca',
            weight: 14,
            description: {
              processed: '<p>list-view</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '9e888882-d71e-4170-bf68-ad39026bb135',
            name: 'Clear',
            langcode: 'en-ca',
            weight: 15,
            description: {
              processed: '<p>clear</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '0b703fdd-5d9a-410e-aecf-6b9e09aba1f2',
            name: 'Apply',
            langcode: 'en-ca',
            weight: 16,
            description: {
              processed: '<p>apply</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '897d8c45-df2f-4a08-a618-0d1f6e3847a2',
            name: 'Search',
            langcode: 'en-ca',
            weight: 17,
            description: {
              processed: '<p>searchSubmit</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '96e370e6-e891-4e1b-85b4-885c94c495c8',
            name: 'Clear input',
            langcode: 'en-ca',
            weight: 18,
            description: {
              processed: '<p>clearInput</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'f8660042-4544-4f26-824b-5c77097d8793',
            name: 'Use geolocation',
            langcode: 'en-ca',
            weight: 19,
            description: {
              processed: '<p>geoLocation</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
            name: 'Color / Wheels',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>paint</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
            name: 'Background',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>environment</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'bb8d18a8-84cd-46b4-84a2-9c6bc56e5c26',
            name: 'Now Playing:',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>titlePlaying</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '451375e7-8d76-4317-a82f-864b0202b351',
            name: 'Close video',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>labelButtonClose</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'c197b04a-bd7a-4f18-bb85-b6c2c8aac067',
            name: 'القصة السابقة',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'c5e01efb-131d-4c63-b7b2-39139703b71f',
            name: 'القصة التالية',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2182f223-4401-4d41-bdc4-b58f6227ae85',
            name: 'Previous trim',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'a021dace-35a5-49f7-aae7-2d9c85c4e674',
            name: 'Next trim',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '513de3d9-a963-4788-befa-83d4fb359993',
            name: 'Play video',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>playVideoButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'bb8d18a8-84cd-46b4-84a2-9c6bc56e5c26',
            name: 'يعرض الآن:',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>titlePlaying</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '451375e7-8d76-4317-a82f-864b0202b351',
            name: 'أغلق الفيديو',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>labelButtonClose</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'bb8d18a8-84cd-46b4-84a2-9c6bc56e5c26',
            name: 'Now Playing:',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>titlePlaying</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '451375e7-8d76-4317-a82f-864b0202b351',
            name: 'Close video',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>labelButtonClose</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e1263273-6307-4cf8-bf7c-7624ed0e4c99',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '58e55203-b82e-4f19-9401-1912f1fb76af',
            name: 'Disclaimers',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>section-disclaimer-title</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'd4bdf41d-1572-41c6-8af0-a318dc875ae6',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
            name: 'Interior',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>theme</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
            name: 'Background',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>environment</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '161e7986-4e03-43c4-8f38-83fbcb0d3f80',
            name: 'افتح',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>reveal</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'cbc21ceb-a7b4-4604-9280-828d95ddf837',
            name: 'قريب',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>hide</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '7613a453-1466-4543-86b6-07e1c4bc1be2',
            name: 'تحميل',
            langcode: 'ar',
            weight: 2,
            description: {
              processed: '<p>download</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '161e7986-4e03-43c4-8f38-83fbcb0d3f80',
            name: 'Open',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>reveal</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'cbc21ceb-a7b4-4604-9280-828d95ddf837',
            name: 'Close',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>hide</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '7613a453-1466-4543-86b6-07e1c4bc1be2',
            name: 'Download',
            langcode: 'en',
            weight: 2,
            description: {
              processed: '<p>download</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '161e7986-4e03-43c4-8f38-83fbcb0d3f80',
            name: 'Open',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>reveal</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'cbc21ceb-a7b4-4604-9280-828d95ddf837',
            name: 'Close',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>hide</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '7613a453-1466-4543-86b6-07e1c4bc1be2',
            name: 'Download',
            langcode: 'en-ca',
            weight: 2,
            description: {
              processed: '<p>download</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c015de08-5439-4ee8-9011-62c6626128be',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'e4598129-1948-4231-813e-f879b5650e82',
            name: 'اعرض الشريحة التالية',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '243cc9e8-028b-4f0b-9b51-2ffe23585efe',
            name: 'اعرض الشريحة السابقة',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'e4598129-1948-4231-813e-f879b5650e82',
            name: 'Show next slide',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '243cc9e8-028b-4f0b-9b51-2ffe23585efe',
            name: 'Show previous slide',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '144d7db4-24b0-4b40-b3ba-006a6e88ba5a',
            name: 'Lucid home',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>logo</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'dd427311-f0f3-4283-9cf9-3f6630dce7f3',
            name: 'Menu',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>hamburger</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '96d6dc56-e599-4ee5-85ed-92704f5a46ee',
            name: 'Skip to main content',
            langcode: 'en',
            weight: 2,
            description: {
              processed: '<p>skip-to-main-content</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '588bf7f0-219a-4129-9d80-2b1de2b09901',
            name: 'Play animations',
            langcode: 'en',
            weight: 3,
            description: {
              processed: '<p>enable-animations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'ce498339-3b3e-4724-a196-7d9a8b8e00b5',
            name: 'Pause animations',
            langcode: 'en',
            weight: 4,
            description: {
              processed: '<p>disable-animations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '435c4f40-eeeb-42dd-b2fc-d64d9e46b869',
            name: 'Close Menu',
            langcode: 'en',
            weight: 5,
            description: {
              processed: '<p>close-side-menu</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '3e9ce828-42f0-45d8-9d59-0859f907ec92',
            name: 'البحث عن مدينة، بلد',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>placeholder</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'fe8a4823-48ad-4c61-8246-f41d01314495',
            name: 'فلاتر',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>filters</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '5b5054b0-2efa-4db4-a643-9aa5d004e556',
            name: 'اخفي الفلتر',
            langcode: 'ar',
            weight: 2,
            description: {
              processed: '<p>hide-filter</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'a187ca01-36a9-47b5-af88-c0709f7c48a6',
            name: 'موقع',
            langcode: 'ar',
            weight: 3,
            description: {
              processed: '<p>location</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'e29ff987-e68a-4152-8b27-dccba423ca46',
            name: 'مواقع',
            langcode: 'ar',
            weight: 4,
            description: {
              processed: '<p>locations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '117c168b-0efe-4be7-a18f-04ab920761fb',
            name: 'لا توجد نتائج',
            langcode: 'ar',
            weight: 5,
            description: {
              processed: '<p>no-results</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'd2d9f25d-4a25-4918-ba76-276792111331',
            name: 'عودة',
            langcode: 'ar',
            weight: 6,
            description: {
              processed: '<p>back</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'ca5e6ebc-7cd0-4828-8e73-d9ee248a7641',
            name: 'اتجاهات القيادة',
            langcode: 'ar',
            weight: 7,
            description: {
              processed: '<p>driving-directions</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '26530d8e-bbb7-4f66-9e19-0ff9fac5af21',
            name: 'استوديو',
            langcode: 'ar',
            weight: 8,
            description: {
              processed: '<p>studio</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '19b9ba81-727a-45a8-ba07-a6976af8a3c6',
            name: 'مركز خدمة',
            langcode: 'ar',
            weight: 9,
            description: {
              processed: '<p>service-center</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '58f797a1-c9aa-4969-874a-971e353e8f38',
            name: 'شاحن',
            langcode: 'ar',
            weight: 10,
            description: {
              processed: '<p>charging-station</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '19314a79-2d4e-43f7-bc71-d4a5b64d694b',
            name: 'قريباً',
            langcode: 'ar',
            weight: 11,
            description: {
              processed: '<p>coming-soon</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '98828aee-50d3-41c7-be6c-d7e117f93d30',
            name: 'اعرض الفلتر',
            langcode: 'ar',
            weight: 12,
            description: {
              processed: '<p>show-filters</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '6af274ce-950e-48ad-8a88-bd7735e437bf',
            name: 'عرض الخريطة',
            langcode: 'ar',
            weight: 13,
            description: {
              processed: '<p>map-view</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '933e0a60-4992-404e-94cb-cfb6954cabb4',
            name: 'عرض القائمة',
            langcode: 'ar',
            weight: 14,
            description: {
              processed: '<p>list-view</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '9e888882-d71e-4170-bf68-ad39026bb135',
            name: 'مسح',
            langcode: 'ar',
            weight: 15,
            description: {
              processed: '<p>clear</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '0b703fdd-5d9a-410e-aecf-6b9e09aba1f2',
            name: 'تطبيق',
            langcode: 'ar',
            weight: 16,
            description: {
              processed: '<p>apply</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '897d8c45-df2f-4a08-a618-0d1f6e3847a2',
            name: 'بحث',
            langcode: 'ar',
            weight: 17,
            description: {
              processed: '<p>searchSubmit</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '96e370e6-e891-4e1b-85b4-885c94c495c8',
            name: 'مسح المدخلات',
            langcode: 'ar',
            weight: 18,
            description: {
              processed: '<p>clearInput</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'f8660042-4544-4f26-824b-5c77097d8793',
            name: 'استخدام الموقع الجغرافي',
            langcode: 'ar',
            weight: 19,
            description: {
              processed: '<p>geoLocation</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
            name: 'في الداخل',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>theme</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
            name: 'الخلفية',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>environment</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '144d7db4-24b0-4b40-b3ba-006a6e88ba5a',
            name: 'Lucid home',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>logo</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'dd427311-f0f3-4283-9cf9-3f6630dce7f3',
            name: 'Menu',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>hamburger</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '96d6dc56-e599-4ee5-85ed-92704f5a46ee',
            name: 'Skip to main content',
            langcode: 'en-ca',
            weight: 2,
            description: {
              processed: '<p>skip-to-main-content</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '588bf7f0-219a-4129-9d80-2b1de2b09901',
            name: 'Play animations',
            langcode: 'en-ca',
            weight: 3,
            description: {
              processed: '<p>enable-animations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'ce498339-3b3e-4724-a196-7d9a8b8e00b5',
            name: 'Pause animations',
            langcode: 'en-ca',
            weight: 4,
            description: {
              processed: '<p>disable-animations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '435c4f40-eeeb-42dd-b2fc-d64d9e46b869',
            name: 'Close Menu',
            langcode: 'en-ca',
            weight: 5,
            description: {
              processed: '<p>close-side-menu</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
            name: 'Interior',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>theme</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
            name: 'Background',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>environment</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
            name: 'Exterior',
            langcode: 'en-ca',
            weight: 0,
            description: null,
            relationships: {
              parent: [
                {
                  drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                },
              ],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
                  name: 'Colour / Wheels',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>paint</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
                  name: 'Background',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>environment</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
            name: 'Interior',
            langcode: 'en-ca',
            weight: 1,
            description: null,
            relationships: {
              parent: [
                {
                  drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                },
              ],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
                  name: 'Interior',
                  langcode: 'en-ca',
                  weight: 0,
                  description: {
                    processed: '<p>theme</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
                  name: 'Background',
                  langcode: 'en-ca',
                  weight: 1,
                  description: {
                    processed: '<p>environment</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '2182f223-4401-4d41-bdc4-b58f6227ae85',
            name: 'Previous trim',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'a021dace-35a5-49f7-aae7-2d9c85c4e674',
            name: 'Next trim',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'e4598129-1948-4231-813e-f879b5650e82',
            name: 'Show next slide',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '243cc9e8-028b-4f0b-9b51-2ffe23585efe',
            name: 'Show previous slide',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'b596b905-8c4d-4053-815d-ab6776665c07',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'c197b04a-bd7a-4f18-bb85-b6c2c8aac067',
            name: 'Previous story',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'c5e01efb-131d-4c63-b7b2-39139703b71f',
            name: 'Next story',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '025616d9-575d-40b6-83d0-e4c1da5f20eb',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '144d7db4-24b0-4b40-b3ba-006a6e88ba5a',
            name: 'لوسِد الصفحة الرئيسية',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>logo</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'dd427311-f0f3-4283-9cf9-3f6630dce7f3',
            name: 'قائمة',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>hamburger</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '96d6dc56-e599-4ee5-85ed-92704f5a46ee',
            name: 'Skip to main content',
            langcode: 'ar',
            weight: 2,
            description: {
              processed: '<p>skip-to-main-content</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '588bf7f0-219a-4129-9d80-2b1de2b09901',
            name: 'تشغيل الرسوم المتحركة',
            langcode: 'ar',
            weight: 3,
            description: {
              processed: '<p>enable-animations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'ce498339-3b3e-4724-a196-7d9a8b8e00b5',
            name: 'إيقاف الرسوم المتحركة مؤقتًا',
            langcode: 'ar',
            weight: 4,
            description: {
              processed: '<p>disable-animations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '435c4f40-eeeb-42dd-b2fc-d64d9e46b869',
            name: 'Close Menu',
            langcode: 'ar',
            weight: 5,
            description: {
              processed: '<p>close-side-menu</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e4c02d5c-6bc9-49fc-9dc3-77e27568f432',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '513de3d9-a963-4788-befa-83d4fb359993',
            name: 'Play video',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>playVideoButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '513de3d9-a963-4788-befa-83d4fb359993',
            name: 'شغل الفيديو',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>playVideoButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'e9e11aa3-7aca-42e8-bec1-29cde4be99af',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2182f223-4401-4d41-bdc4-b58f6227ae85',
            name: 'الزخارف السابقة',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>arrowLeftButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'a021dace-35a5-49f7-aae7-2d9c85c4e674',
            name: 'الزخارف التالية',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>arrowRightButton</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: 'c089294c-dc1e-4615-9d95-272871739d8b',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '3e9ce828-42f0-45d8-9d59-0859f907ec92',
            name: 'Search City, Country',
            langcode: 'en',
            weight: 0,
            description: {
              processed: '<p>placeholder</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'fe8a4823-48ad-4c61-8246-f41d01314495',
            name: 'Filters',
            langcode: 'en',
            weight: 1,
            description: {
              processed: '<p>filters</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '5b5054b0-2efa-4db4-a643-9aa5d004e556',
            name: 'Hide Filter',
            langcode: 'en',
            weight: 2,
            description: {
              processed: '<p>hide-filter</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'a187ca01-36a9-47b5-af88-c0709f7c48a6',
            name: 'Location',
            langcode: 'en',
            weight: 3,
            description: {
              processed: '<p>location</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'e29ff987-e68a-4152-8b27-dccba423ca46',
            name: 'Locations',
            langcode: 'en',
            weight: 4,
            description: {
              processed: '<p>locations</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '117c168b-0efe-4be7-a18f-04ab920761fb',
            name: 'No results',
            langcode: 'en',
            weight: 5,
            description: {
              processed: '<p>no-results</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'd2d9f25d-4a25-4918-ba76-276792111331',
            name: 'Back',
            langcode: 'en',
            weight: 6,
            description: {
              processed: '<p>back</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'ca5e6ebc-7cd0-4828-8e73-d9ee248a7641',
            name: 'Driving Directions',
            langcode: 'en',
            weight: 7,
            description: {
              processed: '<p>driving-directions</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '26530d8e-bbb7-4f66-9e19-0ff9fac5af21',
            name: 'Studio',
            langcode: 'en',
            weight: 8,
            description: {
              processed: '<p>studio</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '19b9ba81-727a-45a8-ba07-a6976af8a3c6',
            name: 'Service center',
            langcode: 'en',
            weight: 9,
            description: {
              processed: '<p>service-center</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '58f797a1-c9aa-4969-874a-971e353e8f38',
            name: 'Charger',
            langcode: 'en',
            weight: 10,
            description: {
              processed: '<p>charging-station</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '19314a79-2d4e-43f7-bc71-d4a5b64d694b',
            name: 'Coming soon',
            langcode: 'en',
            weight: 11,
            description: {
              processed: '<p>coming-soon</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '98828aee-50d3-41c7-be6c-d7e117f93d30',
            name: 'Show filter',
            langcode: 'en',
            weight: 12,
            description: {
              processed: '<p>show-filters</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '6af274ce-950e-48ad-8a88-bd7735e437bf',
            name: 'Map View',
            langcode: 'en',
            weight: 13,
            description: {
              processed: '<p>map-view</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '933e0a60-4992-404e-94cb-cfb6954cabb4',
            name: 'List View',
            langcode: 'en',
            weight: 14,
            description: {
              processed: '<p>list-view</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '9e888882-d71e-4170-bf68-ad39026bb135',
            name: 'Clear',
            langcode: 'en',
            weight: 15,
            description: {
              processed: '<p>clear</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '0b703fdd-5d9a-410e-aecf-6b9e09aba1f2',
            name: 'Apply',
            langcode: 'en',
            weight: 16,
            description: {
              processed: '<p>apply</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '897d8c45-df2f-4a08-a618-0d1f6e3847a2',
            name: 'Search',
            langcode: 'en',
            weight: 17,
            description: {
              processed: '<p>searchSubmit</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '96e370e6-e891-4e1b-85b4-885c94c495c8',
            name: 'Clear input',
            langcode: 'en',
            weight: 18,
            description: {
              processed: '<p>clearInput</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'f8660042-4544-4f26-824b-5c77097d8793',
            name: 'Use geolocation',
            langcode: 'en',
            weight: 19,
            description: {
              processed: '<p>geoLocation</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '663fe55b-a5fe-4b2c-8f0b-a0cbdf853a26',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
            name: 'الألوان / العجلات',
            langcode: 'ar',
            weight: 0,
            description: {
              processed: '<p>paint</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
            name: 'الخلفية',
            langcode: 'ar',
            weight: 1,
            description: {
              processed: '<p>environment</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
            name: 'Exterior',
            langcode: 'ar',
            weight: 0,
            description: null,
            relationships: {
              parent: [
                {
                  drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                },
              ],
              taxonomy_term__component_labels: [
                {
                  drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
                  name: 'الألوان / العجلات',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>paint</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
                  name: 'الخلفية',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>environment</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
            name: 'Interior',
            langcode: 'ar',
            weight: 1,
            description: null,
            relationships: {
              parent: [
                {
                  drupal_id: 'f7e66222-6cc0-4074-844e-a3d5c7b9d299',
                },
              ],
              taxonomy_term__component_labels: [
                {
                  drupal_id: '40beb655-8e39-454c-88fe-30692917008e',
                  name: 'في الداخل',
                  langcode: 'ar',
                  weight: 0,
                  description: {
                    processed: '<p>theme</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
                {
                  drupal_id: '2048bc2c-eec8-46c0-9b6b-6f0033f7b110',
                  name: 'الخلفية',
                  langcode: 'ar',
                  weight: 1,
                  description: {
                    processed: '<p>environment</p>\n',
                  },
                  relationships: {
                    parent: [
                      {
                        drupal_id: '28ec5721-52e8-4f4d-ace1-5974ece479c9',
                      },
                    ],
                    taxonomy_term__component_labels: null,
                  },
                },
              ],
            },
          },
        },
        {
          node: {
            drupal_id: 'dd307a3f-c961-4398-933e-b3bfffbfade4',
            name: 'Colour / Wheels',
            langcode: 'en-ca',
            weight: 0,
            description: {
              processed: '<p>paint</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
        {
          node: {
            drupal_id: '2d52e5f1-f244-4b72-b44b-cb82391c0655',
            name: 'Background',
            langcode: 'en-ca',
            weight: 1,
            description: {
              processed: '<p>environment</p>\n',
            },
            relationships: {
              parent: [
                {
                  drupal_id: '9536fc7d-f8ae-4cf4-a72e-c2db582a3afa',
                },
              ],
              taxonomy_term__component_labels: null,
            },
          },
        },
      ],
    },
  };

  let data = allData.allTaxonomyTermComponentLabels.edges.filter(
    component => component.node.relationships.parent.length === 0
  );
  return data;
}
